import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import * as React from 'react';
export default {
  LeadParagraph,
  React
};